import { Component } from "@angular/core";
import { ForgeFooterModule } from "@tylertech/forge-angular-internal";
import { RouterModule } from "@angular/router";
import { InstanceConfigService } from "src/app/core/services/instance-config.service";
import { AsyncPipe } from "@angular/common";

@Component({
  selector: 'instance-footer',
  standalone: true,
  imports: [ForgeFooterModule, RouterModule, AsyncPipe],
  template: `
    <forge-footer>
      <forge-footer-item>
        <a href="{{alias$ | async}}">{{(siteTitle$ | async) || 'Home'}}</a>
      </forge-footer-item>
      <forge-footer-item>
        <a href="https://www.tylertech.com/terms">Terms of use</a>
      </forge-footer-item>
      <forge-footer-item>
        <a href="https://www.tylertech.com/privacy">Privacy policy</a>
      </forge-footer-item>
      <forge-footer-item>
        <a [routerLink]="['/admin']">Admin Login</a>
      </forge-footer-item>
      <forge-footer-item><span>© 2025</span></forge-footer-item>
    </forge-footer>
  `,
  styleUrls: ['./instance-footer.component.scss']
})

export class InstanceFooterComponent {
  readonly siteTitle$ = this.instanceConfigService.siteTitle$;
  readonly alias$ = this.instanceConfigService.alias$;

  constructor(private readonly instanceConfigService: InstanceConfigService) {}
}